

export const ExposureColors = [
    '#00CD80',
    '#FF5733',
    '#C70039',
]

export const mapExposureColor = (value) => {
  if (value < 30) {
    return ExposureColors[0];
  } else if (value < 60) {
    return ExposureColors[1];
  } else {
    return ExposureColors[2];
  }
};


const prepareMaxExposuresForChart = (o)=>{
    let a = [];
    for (let k in o){
        if (o[k] > 0) {
            a.push({
                x: k.toUpperCase(), value: (o[k] * 100).toFixed(1),
                normal:{label: {enabled: true}}
            })
        }
    }
    a.sort((_a, _b)=>{return _b.value-_a.value});
    return a;
}


export const findMaximumExposures = (tree, {symbols={}, weightFactor=1}={})=>{
    for (let k in tree){
        if (tree[k].hasOwnProperty('tree')){
            findMaximumExposures(tree[k].tree, {
                symbols: symbols,
                weightFactor: weightFactor * tree[k].wgt
            });
        }
        else{
            if (!symbols.hasOwnProperty(k)){
                symbols[k] = 0;
            }
            if (tree[k].wgt === 0 || weightFactor < 1) {
                symbols[k] += weightFactor;
            }
            else if (tree[k].wgt > 0 && weightFactor === 1){
                // Best guess here is a static holding. We need a way to check if previous was leaderboard
                symbols[k] += tree[k].wgt
            }
        }
    }
    return prepareMaxExposuresForChart(symbols);
}